import { CachedStorage } from 'web-cached-persistence'

export let CachedUserInfo = new CachedStorage('userInfo')
